import { render, staticRenderFns } from "./AreaOfResponsibilityList.vue?vue&type=template&id=1563efde"
import script from "./AreaOfResponsibilityList.vue?vue&type=script&lang=js"
export * from "./AreaOfResponsibilityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports